<template>
  <div 
    class="video-html dual-video" 
    :class="[{ 'has-started-full': hasStartedFull }, $attrs.class]"
  >
    <!-- Preview video -->
    <video
      v-show="!isPlayingFull && !hasStartedFull"
      ref="previewVideoElement"
      :src="props.videoPreview"
      :controls="false"
      :muted="true"
      :loop="true"
      playsinline
      :autoplay="true"
      preload="metadata"
    />
    
    <!-- Full video -->
    <video
      v-show="isPlayingFull || hasStartedFull"
      ref="fullVideoElement"
      :src="props.fullVideo"
      :controls="true"
      :muted="false"
      :loop="false"
      playsinline
      :autoplay="false"
      preload="none"
    />
    
    <!-- Play overlay quando è completamente zoomato O quando il full video è disponibile ma non sta suonando -->
    <button 
      v-if="(props.isFullyZoomed || hasStartedFull) && !isPlayingFull"
      class="play-overlay button-round-play"
      @click="playFullVideo"
    >
      <span>Play</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'WidgetVideoMasonry',
  inheritAttrs: false
}
</script>

<script setup>
const props = defineProps({
  videoPreview: {
    type: String,
    required: true
  },
  fullVideo: {
    type: String,
    required: true
  },
  isFullyZoomed: {
    type: Boolean,
    default: false
  }
})

const previewVideoElement = ref(null)
const fullVideoElement = ref(null)
const isPlayingFull = ref(false)
const hasStartedFull = ref(false) // Track se il full video è mai stato avviato

// Dual video
const playFullVideo = () => {
  isPlayingFull.value = true
  hasStartedFull.value = true // Marca che il full video è stato avviato
  nextTick(() => {
    const video = fullVideoElement.value
    if (video) {
      // Se il video era già stato avviato, continua dalla posizione corrente
      // altrimenti parte dall'inizio
      video.play()
    }
  })
}

const resetFullVideo = () => {
  if (fullVideoElement.value) {
    fullVideoElement.value.pause()
    fullVideoElement.value.currentTime = 0
  }
  isPlayingFull.value = false
  hasStartedFull.value = false // Reset anche questo stato per tornare al preview
}

// Watch per stato di zoom
watch(() => props.isFullyZoomed, (newValue) => {
  if (!newValue && isPlayingFull.value) {
    // Quando si scrolla via dal video e il full video sta suonando
    // Pausa il video ma mantieni la posizione corrente
    if (fullVideoElement.value) {
      fullVideoElement.value.pause()
    }
    isPlayingFull.value = false
  }
})

defineExpose({
  previewVideoElement,
  fullVideoElement,
  resetFullVideo,
})
</script>

<style lang="scss">
@import './style.scss';
</style>